import React, { useState } from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Alert,
  Input,
  Tooltip,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { getOfferingList } from '../../api/offering';
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from 'moment';
import Select from 'react-select';
import { updateBatch } from '../../api/batch';
import PageDataLoader from '../Utility/PageDataLoader';
import { getStaffList } from '../../api/staff';
import { scheduleEnum } from '../Utility/Enumerator';
import FormUpload from '../../components/FormUpload';
import QuarterFeesTable from '../../components/QuarterFeesTable';
import { viewSections } from '../../api/section';
import { fetchBatchTransactionCount } from '../../api/batch';

const UpdateBatchModal = ({
  modalOpenState,
  closeModalHandler,
  authUser,
  fetchNewBatchList,
  batchInfoLoading,
  batchInfo
}) => {
  const scheduleOptions = scheduleEnum;
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [offeringOptions, setOfferingOptions] = useState([]);
  const [offeringOptionsLoading, setOfferingOptionsLoading] = useState(false);
  const [selectedOffering, setSelectedOffering] = useState(null);
  const [totalFee, setTotalFee] = useState(0);
  const [sessFee, setSessionlFee] = useState(0);
  const [noOfSessions, setNumberOfSessions] = useState(1);
  const [staffOptions, setStaffOptions] = useState([]);
  const [staffOptionsLoading, setStaffOptionsLoading] = useState(false);
  const [selectedPrimaryTeacher, setSelectedPrimaryTeacher] = useState(null);
  const [selectedSecondaryTeacher, setSelectedSecondaryTeacher] =
    useState(null);
  const [sectionLoading, setSectionLoading] = useState(false);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [transactionCount, setTransactionCount] = useState(0);
  const [tooltipOpen, setTooltipOpen] = useState({});
  const [activeTab, setActiveTab] = useState('1');
  const [dummyQuarter, setDummyQuarter] = useState(false);
  const [quarters, setQuarters] = useState([
    {
      month: '',
      base_fee: 0,
      penalty_day: 1,
      penalty_percentage: 0,
      alert_day: 5,
    }
  ]);
  const [hasCron, setHasCron] = useState(false);
  const [noteRequired, setNoteRequired] = useState(true);
  const [penaltyMode, setPenaltyMode] = useState('percentage');

  const [sessionBatch, setSessionbatch] = useState({
    value: false,
    label: 'Normal Batch'
  });

  const [batchType] = useState([
    {
      value: false,
      label: 'Normal Batch'
    },
    {
      value: true,
      label: 'Session Batch'
    }
  ]);

  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });
  const [batchUpdateRequestLoading, setBatchUpdateRequestLoading] =
    useState(false);
  const [successAlert, setSuccessAlert] = useState({
    message: '',
    show_alert: false
  });
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (authUser) {
      fetchOfferingOptions();
      fetchStaffOptions();
      fetchSections();
    }
    // eslint-disable-next-line
  }, [authUser, modalOpenState]);

  const fetchSections = async () => {
    setSectionLoading(true);
    const response = await viewSections(1, 100);
    if (response) {
      setSectionOptions(buildOptions(response?.data || []));
      setSectionLoading(false);
    }
  };

  useEffect(() => {
    if (
      batchInfo &&
      offeringOptions.length > 0 &&
      staffOptions.length > 0 &&
      sectionOptions.length > 0
    ) {
      setQuarters(
        batchInfo.quarters || [
          {
            month: '',
            base_fee: 0,
            penalty_day: 1,
            penalty_percentage: 0,
            alert_day: 5
          }
        ]
      );
      setSelectedOffering(
        offeringOptions.find((k) => k.value === batchInfo?.offering?._id)
      );
      setSelectedPrimaryTeacher(
        staffOptions.find((k) => k.value === batchInfo?.primary_teacher?._id)
      );
      setSelectedSecondaryTeacher(
        staffOptions.find((k) => k.value === batchInfo?.secondary_teacher?._id)
      );

      setSelectedSchedule(
        scheduleOptions.find((k) => k.value === batchInfo?.schedule)
      );

      setAttributes(buildOptions(batchInfo?.attributes || []));

      setTotalFee(batchInfo.totalFee || 0);
      setSessionbatch({
        value: batchInfo?.isSessionBatch || false,
        label: batchInfo?.isSessionBatch ? 'Session Batch' : 'Normal Batch'
      });
      setSessionlFee(batchInfo?.sessionFee || 0);
      setNumberOfSessions(batchInfo?.totalSessions || 1);
      setHasCron(batchInfo?.hasCron || false);
      setNoteRequired(batchInfo?.noteRequired !== false);
      setPenaltyMode(batchInfo?.penaltyMode || 'percentage');
    }
    // eslint-disable-next-line
  }, [batchInfo, offeringOptions, sectionOptions]);

  const fetchOfferingOptions = async () => {
    setOfferingOptionsLoading(true);
    const response = await getOfferingList(1, 100);
    if (response) {
      setOfferingOptions(buildOptions(response?.data || []));
      setOfferingOptionsLoading(false);
    }
  };

  const fetchStaffOptions = async () => {
    setStaffOptionsLoading(true);
    const response = await getStaffList(1, 100);
    if (response) {
      setStaffOptions(buildOptions(response?.data || []));
      setStaffOptionsLoading(false);
    }
  };

  function buildOptions(list) {
    return list.map((item) => ({
      value: item._id,
      label: item.name
    }));
  }

  const handleSectionToggle = (selectedData) => {
    setAttributes(selectedData);
  };

  async function handleBatchUpdate(event, values) {
    resetErrorAlert();

    // Basic details validation
    if (!selectedOffering) {
      showErrorAlert('Please select a Offering for the Batch');
      return;
    }
    if (!selectedSchedule) {
      showErrorAlert('Please select a schedule');
      return;
    }

    // Fees validation (only if we're on fees tab or both tabs need to be validated)
    if (!sessionBatch.value) {
      let tempTotalFee = 0;
      Object.keys(values).forEach((q) => {
        if (['quarter1', 'quarter2', 'quarter3', 'quarter4'].includes(q)) {
          tempTotalFee += Number(values[q]?.base_fee || 0);
        }
      });

      if (tempTotalFee !== Number(totalFee)) {
        showErrorAlert('Quarter Base fees must be equal to Batch total Fees');
        return;
      }
    }

    let form = new FormData();

    // Basic details
    form.set('name', values.name);
    form.set('offering', selectedOffering.value);
    form.set('start_date', values.start_date);
    form.set('end_date', values.end_date);
    form.set('start_time', values.start_time);
    form.set('end_time', values.end_time);
    form.set('schedule', selectedSchedule.value);
    form.set('summary', values.summary);
    form.set('detail', values.detail);
    form.set('color', values.color);
    form.set('hasCron', hasCron);
    form.set('noteRequired', noteRequired);

    if (selectedPrimaryTeacher)
      form.set('primary_teacher', selectedPrimaryTeacher?.value);
    if (selectedSecondaryTeacher)
      form.set('secondary_teacher', selectedSecondaryTeacher?.value);

    if (images && images.length > 0) {
      images.map((g, index) => form.append(`pictures`, g));
    }

    if (attributes.length > 0) {
      attributes.forEach((attribute) => {
        form.append('attributes', attribute.value);
      });
    }

    // Fees details
    form.set('sessionFee', parseInt(sessFee) || 0);
    form.set('totalFee', parseInt(totalFee) || 0);
    form.set('totalSessions', parseInt(noOfSessions));
    form.set('isSessionBatch', sessionBatch.value);

    if (!sessionBatch.value) {
      form.set('penaltyMode', penaltyMode);
      ['quarter1', 'quarter2', 'quarter3', 'quarter4'].map((q) => {
        if (values[`${q}`]) {
          form.set(`${q}.month`, values[`${q}`].month);
          form.set(`${q}.base_fee`, values[`${q}`].base_fee);
          form.set(`${q}.alert_day`, values[`${q}`].alert_day);
          form.set(`${q}.penalty_day`, values[`${q}`].penalty_day);
          form.set(`${q}.penalty_percentage`, values[`${q}`].penalty_percentage);
        }
      });
    }

    setBatchUpdateRequestLoading(true);
    const { response, error } = await updateBatch(batchInfo._id, form);
    setBatchUpdateRequestLoading(false);
    if (error) {
      showErrorAlert(error);
      return;
    }
    setNumberOfSessions(1);
    setTotalFee(0);
    setSessionlFee(0);
    setSessionbatch({
      value: false,
      label: 'Normal Batch'
    });
    closeModalHandler();
    showSuccessAlert(response.message);
    fetchNewBatchList();
  }

  async function handleBasicDetailsUpdate(event, values) {
    resetErrorAlert();

    // Basic details validation
    if (!selectedOffering) {
      showErrorAlert('Please select a Offering for the Batch');
      return;
    }
    if (!selectedSchedule) {
      showErrorAlert('Please select a schedule');
      return;
    }

    let form = new FormData();

    // Only basic details
    form.set('name', values.name);
    form.set('offering', selectedOffering.value);
    form.set('start_date', values.start_date);
    form.set('end_date', values.end_date);
    form.set('start_time', values.start_time);
    form.set('end_time', values.end_time);
    form.set('schedule', selectedSchedule.value);
    form.set('summary', values.summary);
    form.set('detail', values.detail);
    form.set('color', values.color);
    form.set('hasCron', hasCron);
    form.set('noteRequired', noteRequired);

    if (selectedPrimaryTeacher)
      form.set('primary_teacher', selectedPrimaryTeacher?.value);
    if (selectedSecondaryTeacher)
      form.set('secondary_teacher', selectedSecondaryTeacher?.value);

    if (images && images.length > 0) {
      images.map((g, index) => form.append(`pictures`, g));
    }

    if (attributes.length > 0) {
      attributes.forEach((attribute) => {
        form.append('attributes', attribute.value);
      });
    }

    setBatchUpdateRequestLoading(true);
    const { response, error } = await updateBatch(batchInfo._id, form);
    setBatchUpdateRequestLoading(false);
    if (error) {
      showErrorAlert(error);
      return;
    }
    closeModalHandler();
    showSuccessAlert(response.message);
    fetchNewBatchList();
  }

  async function handleFeesDetailsUpdate(event, values) {
    resetErrorAlert();

    // Fees validation
    if (!sessionBatch.value) {
      let tempTotalFee = 0;
      quarters.map((q) => {
        tempTotalFee += Number(q.base_fee);
      });

      if (tempTotalFee !== Number(totalFee)) {
        showErrorAlert('Quarter Base fees must be equal to Batch total Fees');
        return;
      }
    }

    let form = new FormData();

    // Only fees details
    form.set('sessionFee', parseInt(sessFee) || 0);
    form.set('totalFee', parseInt(totalFee) || 0);
    form.set('totalSessions', parseInt(noOfSessions));
    form.set('isSessionBatch', sessionBatch.value);

    if (!sessionBatch.value) {
      quarters.map((q) => {
        form.append('quarters', JSON.stringify(q));
      });
      form.set('isDummyQuarter', dummyQuarter);
    }

    setBatchUpdateRequestLoading(true);
    const { response, error } = await updateBatch(batchInfo._id, form);
    setBatchUpdateRequestLoading(false);
    if (error) {
      showErrorAlert(error);
      return;
    }
    setNumberOfSessions(1);
    setTotalFee(0);
    setSessionlFee(0);
    setSessionbatch({
      value: false,
      label: 'Normal Batch'
    });
    setQuarters([
      {
        month: '',
        base_fee: 0,
        penalty_day: 1,
        penalty_percentage: 0,
        alert_day: 5
      }
    ]);
    closeModalHandler();
    showSuccessAlert(response.message);
    fetchNewBatchList();
  }

  function handleAddRemoveQuarters(action) {
    if (action === 'add') {
      const baseFee = sessFee / (quarters.length + 1);
      setSessionlFee(baseFee * (quarters.length + 1));
      setQuarters((prev) => {
        let tempQuarters = [...prev];
        tempQuarters = tempQuarters.map((q) => ({
          ...q,
          base_fee: baseFee
        }));
        tempQuarters.push({
          month: '',
          base_fee: baseFee,
          penalty_day: 1,
          penalty_percentage: 0,
          alert_day: 5
        });
        return tempQuarters;
      });
    } else if (action === 'remove') {
      if (quarters.length === 1) return;
      const baseFee = sessFee / (quarters.length - 1);
      setSessionlFee(baseFee * (quarters.length - 1));
      setQuarters((prev) => {
        let tempQuarters = [...prev];
        tempQuarters.pop();
        tempQuarters = tempQuarters.map((q) => ({
          ...q,
          base_fee: baseFee
        }));
        return tempQuarters;
      });
    }
  }

  function showErrorAlert(message) {
    setRequestError({ message: message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  function showSuccessAlert(message) {
    setSuccessAlert({ message: message, show_alert: true });
  }

  function resetSuccessAlert() {
    setSuccessAlert({ message: '', show_alert: false });
  }

  function resetState() {
    resetSuccessAlert();
    resetErrorAlert();
  }

  function handleSessionFee(e) {
    const value = Number(e.target.value);
    setSessionlFee(value);
    setQuarters((prev) => {
      let updatedQuarters = [...prev];
      const perQuarterFee = value / quarters.length;
      updatedQuarters = updatedQuarters.map((q) => ({
        ...q,
        base_fee: perQuarterFee
      }));
      return updatedQuarters;
    });
    claculateTotalFee({ sessionFee: value });
  }

  function claculateTotalFee({
    sessionFee = sessFee,
    noOfSess = noOfSessions
  }) {
    let value = parseInt(sessionFee) * parseInt(noOfSess);
    setTotalFee(value);
  }

  function handleNoOfSessions(e) {
    setNumberOfSessions(e.target.value);
    claculateTotalFee({ noOfSess: e.target.value });
  }

  function handleSelectSessionType(selectedItem) {
    setTotalFee(0);
    setNumberOfSessions(1);
    setSessionlFee(0);
    claculateTotalFee({ sessionFee: 0, noOfSess: 1 });
    setSessionbatch(selectedItem);
  }

  const toggleTooltip = (id) => {
    setTooltipOpen((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  useEffect(() => {
    if (batchInfo?._id) {
      fetchBatchTransactionCount(batchInfo?._id).then((response) => {
        setTransactionCount(response);
      });
    }
  }, [batchInfo?._id]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <React.Fragment>
      {successAlert.show_alert && (
        <SweetAlert success title="Updated" onConfirm={resetState}>
          {successAlert.message}
        </SweetAlert>
      )}
      <Modal isOpen={modalOpenState} backdrop="static" size="xl">
        <ModalHeader toggle={closeModalHandler}>
          {batchInfoLoading ? 'Loading ...' : 'Edit [' + batchInfo.name + ']'}
        </ModalHeader>
        <ModalBody>
          {batchInfoLoading ? (
            <div className="d-flex justify-content-center">
              <PageDataLoader />
            </div>
          ) : (
            <React.Fragment>
              {requestError ? (
                <Alert
                  color="danger"
                  role="alert"
                  isOpen={requestError.show_alert}
                  toggle={resetErrorAlert}
                >
                  <i className="mdi mdi-block-helper mr-2"></i>
                  {requestError.message}
                </Alert>
              ) : null}

              <Nav tabs className="nav-tabs-custom nav-justified mb-3">
                <NavItem>
                  <NavLink
                    className={activeTab === '1' ? 'activeBatchTab' : ''}
                    onClick={() => toggleTab('1')}
                  >
                    Batch Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === '2' ? 'activeBatchTab' : ''}
                    onClick={() => toggleTab('2')}
                  >
                    Fees Details
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab}>
                {/* Basic Details Tab */}
                <TabPane tabId="1">
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={handleBasicDetailsUpdate}
                    model={{
                      name: batchInfo?.name,
                      color: batchInfo?.color,
                      start_date: batchInfo && moment(new Date(batchInfo.start_date)).format('YYYY-MM-DD'),
                      end_date: batchInfo && moment(new Date(batchInfo.end_date)).format('YYYY-MM-DD'),
                      start_time: batchInfo?.start_time,
                      end_time: batchInfo?.end_time,
                      summary: batchInfo?.summary,
                      detail: batchInfo?.detail,
                    }}
                  >
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label>Batch Name</Label>
                          <AvField
                            name="name"
                            placeholder="Enter Batch Name ..."
                            type="text"
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'Batch name is required'
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="6">
                        <FormGroup>
                          <Label>Offering</Label>
                          <Select
                            options={offeringOptions}
                            disabled={offeringOptionsLoading}
                            onChange={(val) => setSelectedOffering(val)}
                            value={selectedOffering}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Color</Label>
                          <AvField
                            name="color"
                            placeholder="Enter Batch Color ..."
                            type="color"
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'Batch color is required'
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <Label>Start Date</Label>
                          <AvField
                            name="start_date"
                            placeholder="Enter Start Date ..."
                            type="date"
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'Start date is required'
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>End Date</Label>
                          <AvField
                            name="end_date"
                            placeholder="Enter End Date ..."
                            type="date"
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'End date is required'
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Start Time</Label>
                          <AvField
                            name="start_time"
                            placeholder="Enter Start time ..."
                            type="time"
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'Start time is required'
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>End Time</Label>
                          <AvField
                            name="end_time"
                            placeholder="Enter End Time ..."
                            type="time"
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'End time is required'
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Schedule</Label>
                          <Select
                            options={scheduleOptions}
                            onChange={(val) => setSelectedSchedule(val)}
                            value={selectedSchedule}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label>Primary Teacher</Label>
                          <Select
                            options={staffOptions}
                            disabled={staffOptionsLoading}
                            onChange={(val) => setSelectedPrimaryTeacher(val)}
                            value={selectedPrimaryTeacher}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <Label>Secondary Teacher</Label>
                          <Select
                            options={staffOptions}
                            disabled={staffOptionsLoading}
                            onChange={(val) => setSelectedSecondaryTeacher(val)}
                            value={selectedSecondaryTeacher}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup>
                          <Label for="sections">Select attributes</Label>
                          <Select
                            disabled={sectionLoading}
                            options={sectionOptions}
                            isClearable={false}
                            isMulti
                            value={attributes}
                            onChange={(val) => setAttributes(val)}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="12">
                        <FormGroup>
                          <Label>Summary</Label>
                          <AvField
                            name="summary"
                            placeholder="Enter Summary ..."
                            type="text"
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'Summary is required'
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup>
                          <Label>Detail</Label>
                          <AvField
                            name="detail"
                            placeholder="Enter Detail ..."
                            type="textarea"
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'Detail is required'
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="12" className="mb-3">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={noteRequired}
                              onChange={(e) => setNoteRequired(e.target.checked)}
                            />{' '}
                            Require note when recording execution
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md="12" className="mb-3">
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={hasCron}
                              onChange={(e) => setHasCron(e.target.checked)}
                            />{' '}
                            Enable Cron Job
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormUpload title="Images" setImages={setImages} />
                      </Col>
                    </Row>
                    <ModalFooter>
                      <Button
                        disabled={batchUpdateRequestLoading}
                        type="button"
                        color="light"
                        onClick={closeModalHandler}
                      >
                        Close
                      </Button>
                      <Button type="submit" color="success">
                        {batchUpdateRequestLoading
                          ? 'Updating ...'
                          : 'Update Basic Details'}
                      </Button>
                    </ModalFooter>
                  </AvForm>
                </TabPane>

                {/* Fees Details Tab */}
                <TabPane tabId="2">
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={handleFeesDetailsUpdate}
                  >
                    <Row>
                      {batchInfo && !batchInfo?.children?.length ? (
                        <Col md="6">
                          <FormGroup>
                            <Label>Batch Type</Label>
                            <Select
                              options={batchType}
                              onChange={handleSelectSessionType}
                              value={sessionBatch}
                            />
                          </FormGroup>
                        </Col>
                      ) : null}
                      <Col md={sessionBatch?.value ? '2' : '6'}>
                        <FormGroup>
                          <Label>
                            {sessionBatch?.value ? 'Session Fee' : 'Batch Fee'}
                          </Label>
                          <AvField
                            type="number"
                            name="fees"
                            value={sessFee}
                            onChange={(e) => handleSessionFee(e)}
                            className="form-control"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: 'Batch fees is required'
                              }
                            }}
                            // disabled={transactionCount > 0}
                            id="batch-fee-input"
                          />
                          {/* {transactionCount > 0 && (
                            <Tooltip
                              placement="top"
                              isOpen={tooltipOpen['batch-fee']}
                              target="batch-fee-input"
                              toggle={() => toggleTooltip('batch-fee')}
                            >
                              Due to Paid Transactions, this is disabled
                            </Tooltip>
                          )} */}
                        </FormGroup>
                      </Col>

                      {!sessionBatch?.value && (
                        <Col md="6">
                          <Label>Add/Remove Quarters</Label>
                          <div className="d-flex align-items-center g-1">
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => handleAddRemoveQuarters('add')}
                              disabled={dummyQuarter || transactionCount > 0}
                            >
                              Add
                            </Button>
                            <Button
                              color="danger"
                              onClick={() => handleAddRemoveQuarters('remove')}
                              style={{ marginLeft: '10px' }}
                              size="sm"
                              disabled={
                                quarters.length === 1 || transactionCount > 0
                              }
                            >
                              Remove
                            </Button>
                            <Button
                              color="warning"
                              size="sm"
                              style={{ marginLeft: '10px' }}
                              onClick={() => setDummyQuarter(!dummyQuarter)}
                              disabled={transactionCount > 0}
                            >
                              {dummyQuarter ? 'Add Regular Quarter' : 'Add Dummy Quarter'}
                            </Button>
                          </div>
                        </Col>
                      )}

                      {sessionBatch?.value ? (
                        <React.Fragment>
                          <Col md="2">
                            <FormGroup>
                              <Label>Number Of Sessions</Label>
                              <Input
                                type="number"
                                value={noOfSessions}
                                onChange={(e) => handleNoOfSessions(e)}
                                className="form-control"
                              />
                            </FormGroup>
                          </Col>
                          <Col md="2">
                            <FormGroup>
                              <Label>Total Fee</Label>
                              <Input
                                type="number"
                                value={totalFee}
                                onChange={(e) => setTotalFee(e.target.value)}
                                className="form-control"
                                disabled
                              />
                            </FormGroup>
                          </Col>
                        </React.Fragment>
                      ) : null}

                      {/* QUARTER DATA */}
                      {!sessionBatch.value && (
                        <Col md="12">
                          <FormGroup className="mt-3 mb-2" style={{ display: 'flex', alignItems: 'center' }}>
                            <Label className="mb-0 fw-semibold" style={{ marginRight: '16px', whiteSpace: 'nowrap' }}>Penalty Mode</Label>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                              <Label check className="mb-0" style={{ display: 'flex', alignItems: 'center', cursor: transactionCount > 0 ? 'not-allowed' : 'pointer', opacity: transactionCount > 0 ? 0.5 : 1 }}>
                                <input
                                  type="radio"
                                  name="penaltyModeUpdate"
                                  value="daily_flat"
                                  checked={penaltyMode === 'daily_flat'}
                                  onChange={() => setPenaltyMode('daily_flat')}
                                  disabled={transactionCount > 0}
                                  style={{ marginRight: '6px' }}
                                />
                                Per Day Amount (₹)
                              </Label>
                              <Label check className="mb-0" style={{ display: 'flex', alignItems: 'center', cursor: transactionCount > 0 ? 'not-allowed' : 'pointer', opacity: transactionCount > 0 ? 0.5 : 1 }}>
                                <input
                                  type="radio"
                                  name="penaltyModeUpdate"
                                  value="percentage"
                                  checked={penaltyMode === 'percentage'}
                                  onChange={() => setPenaltyMode('percentage')}
                                  disabled={transactionCount > 0}
                                  style={{ marginRight: '6px' }}
                                />
                                Percentage (%)
                              </Label>
                            </div>
                            {transactionCount > 0 && (
                              <small className="text-muted" style={{ marginLeft: '12px' }}>Locked — transactions exist for this batch</small>
                            )}
                          </FormGroup>
                          <QuarterFeesTable
                            quarters={quarters}
                            setQuarters={setQuarters}
                            dummyQuarter={dummyQuarter}
                            useIsoMonthValue
                            ceilBaseFee
                            penaltyMode={penaltyMode}
                          />
                        </Col>
                      )}
                    </Row>
                    <ModalFooter>
                      <Button
                        disabled={batchUpdateRequestLoading}
                        type="button"
                        color="light"
                        onClick={closeModalHandler}
                      >
                        Close
                      </Button>
                      <Button type="submit" color="success">
                        {batchUpdateRequestLoading
                          ? 'Updating ...'
                          : 'Update Fees Details'}
                      </Button>
                    </ModalFooter>
                  </AvForm>
                </TabPane>
              </TabContent>
            </React.Fragment>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(UpdateBatchModal);
